
















































import { Component, Prop, Vue } from "vue-property-decorator";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import {
  PdfTemplateCatalogueCategory,
  PdfTemplateField,
  PdfTemplateValueStatus,
} from "@/data/models/ClientAdministrationRow";
import {
  cloudProblemStatus,
  fieldDescriptionParts,
  isLinked,
  PdfTemplateEditorRow,
  PdfTemplateValueOption,
} from "@/utils/PdfTemplateMapping";

/**
 * The fields of a PDF template and what is linked to each: kind, category, values (with why IRES Cloud
 * leaves one blank, on the certificate's template only) and the text around them. In edit mode a row
 * emits `row-clicked` for the page to open its mapping dialog.
 */
@Component
export default class PdfTemplateFieldTableComponent extends Vue {
  /** The header row tinted like Office's tables (BillingCatalogList). */
  get headerColor(): string {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  @Prop({ required: true })
  rows!: PdfTemplateEditorRow[];

  @Prop({ default: false })
  isEditMode!: boolean;

  @Prop({ required: true })
  catalogue!: PdfTemplateCatalogueCategory[];

  /** The stored fields, for the names of categories the catalogue no longer offers. */
  @Prop({ required: true })
  templateFields!: PdfTemplateField[];

  @Prop({ required: true })
  options!: Map<string, PdfTemplateValueOption>;

  @Prop({ default: false })
  showsCloudStatuses!: boolean;

  isLinked(row: PdfTemplateEditorRow): boolean {
    return isLinked(row);
  }

  valueLabel(value: string): string {
    return this.options.get(value)?.label ?? value;
  }

  categoryLabel(category: string): string {
    return (
      this.catalogue.find((entry) => entry.name === category)?.label ??
      this.templateFields.find((field) => field.category === category)?.categoryLabel ??
      (category || "–")
    );
  }

  problemOf(value: string): PdfTemplateValueStatus | null {
    return cloudProblemStatus(value, this.options, this.showsCloudStatuses);
  }

  fieldDescription(row: PdfTemplateEditorRow): string {
    return fieldDescriptionParts(row)
      .map((part) => (part.count === undefined ? this.$t(part.key) : this.$tc(part.key, part.count)).toString())
      .join(" · ");
  }

  /** "davor: „Nr. “ (Projektnummer Office)" for a prefix, "danach: …" for a suffix. */
  textsOf(row: PdfTemplateEditorRow): string[] {
    return (row.mapping?.transformations ?? []).map((transformation) =>
      this.$t(transformation.type === "POSTFIX" ? "admin.pdfTemplates.detail.suffix" : "admin.pdfTemplates.detail.prefix", [
        transformation.value,
        this.valueLabel(transformation.fieldValue),
      ]).toString()
    );
  }

  onRowClicked(row: PdfTemplateEditorRow) {
    if (this.isEditMode) {
      this.$emit("row-clicked", row);
    }
  }
}
